module.exports = __webpack_public_path__ + "static/media/rlc.2a1bdb72.svg";